import { supabase } from "@/integrations/supabase/client";
import { hasConsent } from "./cookieConsent";

const SESSION_KEY = "ofix_session_id";

export const getSessionId = (): string => {
  if (typeof window === "undefined") return "";
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = `s_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
};

export type LeadSource = "booking_form" | "whatsapp_click" | "call_click" | "diagnostic" | "other";

export interface LeadInput {
  name?: string;
  phone?: string;
  manufacturer?: string;
  model?: string;
  issue_type?: string;
  description?: string;
  preferred_time?: string;
  source?: LeadSource;
}

/** Confirm storage before a callback form reports success. WhatsApp remains independent. */
export const saveLead = async (input: LeadInput): Promise<boolean> => {
  try {
    const { error } = await supabase.from("leads").insert({
      ...input,
      source: input.source ?? "booking_form",
      source_page: typeof window !== "undefined" ? window.location.pathname : null,
      session_id: getSessionId(),
      user_agent: typeof navigator !== "undefined" ? navigator.userAgent.slice(0, 500) : null,
    });
    return !error;
  } catch (err) {
    // Never break the UX because of tracking
    console.warn("[leads] save failed");
    return false;
  }
};

/** Track a lightweight interaction event (WhatsApp/call clicks, etc.). */
export const trackEvent = async (
  eventType: string,
  ctaLocation?: string,
  metadata?: Record<string, unknown>,
): Promise<void> => {
  if (!hasConsent("analytics")) return;
  try {
    await supabase.from("lead_events").insert({
      event_type: eventType,
      cta_location: ctaLocation ?? null,
      page_path: typeof window !== "undefined" ? window.location.pathname : null,
      session_id: getSessionId(),
      referrer: typeof document !== "undefined" ? document.referrer.slice(0, 500) : null,
      user_agent: typeof navigator !== "undefined" ? navigator.userAgent.slice(0, 500) : null,
      metadata: (metadata ?? {}) as never,
    });
  } catch (err) {
    console.warn("[lead_events] track failed", err);
  }
};
